import type { AuditAction, AuditEvent } from "../../hooks/useAuditEvents";
import { detailFor, formatAbsolute, formatRelative, labelFor } from "../../lib/auditEvent";
import styles from "../../pages/AuditTrail.module.css";

const ACTION_CLASS: Record<AuditAction, string> = {
  USER_PROFILE_UPDATED: styles.actionNeutral ?? "",
  CLAW_CREATED: styles.actionCreated ?? "",
  CLAW_DELETED: styles.actionDeleted ?? "",
  CLAW_REASSIGNED: styles.actionNeutral ?? "",
  CLAW_UNLOCKED: styles.actionNeutral ?? "",
  CLAW_LLM_TOKEN_SET: styles.actionNeutral ?? "",
  CLAW_GATEWAY_PASSWORD_SET: styles.actionNeutral ?? "",
  CLAW_CONTROL_UI_IDENTITY_SET: styles.actionNeutral ?? "",
  CLAW_AI_MODE_SWITCHED: styles.actionNeutral ?? "",
};

type AuditEventRowProps = {
  readonly event: AuditEvent;
};

export const AuditEventRow = ({ event }: AuditEventRowProps): JSX.Element => {
  const detail = detailFor(event);
  return (
    <li className={styles.row}>
      <div className={styles.time}>
        <span className={styles.timeRel} title={formatAbsolute(event.eventTime)}>
          {formatRelative(event.eventTime)}
        </span>
        <span className={styles.timeAbs}>{formatAbsolute(event.eventTime)}</span>
      </div>

      <span className={`${styles.action} ${ACTION_CLASS[event.action] ?? ""}`}>
        {labelFor(event.action)}
      </span>

      <div className={styles.body}>
        <div className={styles.name} title={event.tenantName}>
          {event.tenantName}
        </div>
        <div className={styles.meta}>
          <span className={styles.tenantId}>{event.tenantId}</span>
          {event.actorEmail && (
            <>
              <span className={styles.metaDot} aria-hidden>·</span>
              <span>by {event.actorEmail}</span>
            </>
          )}
          {event.targetEmail && event.targetEmail !== event.actorEmail && (
            <>
              <span className={styles.metaDot} aria-hidden>·</span>
              <span>for {event.targetEmail}</span>
            </>
          )}
          {detail && (
            <>
              <span className={styles.metaDot} aria-hidden>·</span>
              <span>{detail}</span>
            </>
          )}
        </div>
      </div>
    </li>
  );
};
